import React from 'react';
import { Bell } from 'lucide-react';
import NotificationVerification from '../components/NotificationVerification';
import './SettingsPage.css';

const SettingsPage: React.FC = () => {
    return (
        <div className="page-container">
            <div className="page-header">
                <h1 className="page-title">設定</h1>
                <p className="page-description">
                    プッシュ通知のセットアップを確認・設定します。
                </p>
            </div>

            <div className="settings-container">
                <div className="settings-main">
                    <div className="settings-header">
                        <div className="settings-title-with-icon">
                            <Bell size={24} />
                            <h2 className="settings-title">プッシュ通知</h2>
                        </div>
                    </div>

                    <div className="settings-content">
                        <NotificationVerification />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SettingsPage;
